export function isReactElement(el) {
  return typeof el !== 'string' && typeof el !== 'number';
}
//# sourceMappingURL=isReactElement.js.map